import type { TFunction } from "i18next"
import { IconButton, Stack, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/DeleteOutlined"
import type { GridColDef } from "@mui/x-data-grid"

import type { UserOrgRole } from "types/users.types"
import type { USER_ROLES } from "helpers/utils/constants"

export const getUsersTableColumns = (
  t: TFunction,
  handleOpenEdit: (username: string, role: keyof typeof USER_ROLES) => void,
  handleOpenDelete: (username: string) => void,
  isOwner: boolean,
): GridColDef<UserOrgRole>[] => {
  return [
    {
      field: "username",
      headerName: t("generic.USERNAME"),
      flex: 1,
      minWidth: 200,
    },
    {
      field: "role",
      headerName: t("generic.ROLE"),
      flex: 1,
      minWidth: 140,
      // Also what the CSV export writes, so the file carries the translated role.
      valueFormatter: (role: string) => t(`roles.${role.toUpperCase()}`),
    },
    {
      field: "actions",
      headerName: t("generic.ACTIONS"),
      headerAlign: "right",
      align: "right",
      sortable: false,
      disableExport: true,
      renderCell: ({ row: { username, role } }) =>
        (isOwner || role !== "owner") && (
          <Stack direction={"row"} gap={1} justifyContent={"end"} alignItems={"center"}>
            <Tooltip title={t("generic.EDIT")}>
              <IconButton size="small" onClick={() => handleOpenEdit(username, role)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("generic.REMOVE")}>
              <IconButton size="small" onClick={() => handleOpenDelete(username)}>
                <DeleteIcon fontSize="small" color="error" />
              </IconButton>
            </Tooltip>
          </Stack>
        ),
    },
  ]
}
